module App.Timeclock {
	export interface Timeclock {
		id: number;
		duration: string;
		active: boolean;
		time_in: Date;
		time_out: Date|null;
		note: string|null;
	}
}
